
import { Component, Vue } from 'vue-property-decorator';
import {
  ActionableHelperView,
  Heading,
  Row,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';

import { Notification } from '@/modules/common/components/Notification';

import { DonutChart } from '@/modules/common/components/charts/DonutChart';
import { AssetTitle } from '@/modules/common/components/AssetTitle';
import { ChartData } from '@/types/models/DonutChart/ChartData';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { ModalFooter } from '@/modules/common/components/__deprecated__/Modal';
import { Steps } from '../PortfolioSuggestedModal/PortfolioSuggestedModal.vue';
import {
  GlobalSummarySuggestedPortfolioDetails,
  PorfolioSuggestedUpdateStatusDocument,
  EGlobalSummaryPortfolioStatus
} from '@/modules/common/services/graphql/server/server.sdk';
import { isImpersonate } from '@/modules/common/services/partner';
import { RiskValidation } from '@/modules/common/components/RiskValidation';
import { namespace } from 'vuex-class';
import { ICustomer, IInvestmentProfile } from '@/types/models';
import { SuggestionModule } from '@/modules/home/store/suggestions';
import { getCustomerInvestmentProfile } from '@/modules/common/services/http/account';

const customerModule = namespace('CustomerModule');

@Component({
  components: {
    RiskValidation,
    LoaderIndicator,
    Notification,
    ActionableHelperView,
    DonutChart,
    Heading,
    Row,
    AssetTitle,
    ModalFooter
  }
})
export default class PortfolioSuggestedDetails extends Vue {
  @customerModule.Getter('getCustomer')
  private customer?: ICustomer;

  private customerId = localStorage.getItem('warren.customerId');
  private isImpersonate = isImpersonate();
  private riskValidation = false;
  public error = false;
  public investmentProfile?: IInvestmentProfile = {};

  reload() {
    SuggestionModule.getSuggestionDetails({
      suggestionId: this.portfolioDetails.id!,
      customerId: this.customer!._id
    });
  }

  async mounted() {
    await this.getCustomerProfile();
  }

  private async getCustomerProfile() {
    if (this.customer) {
      const { investmentProfile } = await getCustomerInvestmentProfile(
        this.customer._id
      );
      this.investmentProfile = investmentProfile;
    }
  }

  private chartData(data: GlobalSummarySuggestedPortfolioDetails): ChartData[] {
    return data.allocation.map(allocation => ({
      label: allocation.name!.formatted,
      value: allocation.allocValue!.value
    }));
  }

  private async acceptPortfolio() {
    if (!this.isImpersonate) {
      this.$apollo
        .mutate({
          mutation: PorfolioSuggestedUpdateStatusDocument,
          variables: {
            customerId: this.customerId,
            portfolioId: this.portfolioId,
            status: EGlobalSummaryPortfolioStatus.Accepted
          }
        })
        .then(() => {
          SuggestionModule.removeSuggestion(this.portfolioId);
          this.notifyUser();
          this.modalNavigate(Steps.List);
        })
        .catch(() => {
          this.error = true;
        });
    }
  }

  private notifyUser() {
    this.$emit('notify-user', {
      group: 'wrn-notification-portfolio-suggestion',
      text: `Carteira ${this.portfolioName} aceita!`,
      type: NotificationTypes.success
    });
  }

  private async aceptedConfirm() {
    await this.acceptPortfolio();
  }

  private modalNavigate(step: Steps) {
    this.$emit('modal-navigate', step);
  }

  private handlerRefuse() {
    this.modalNavigate(Steps.Refuse);
  }

  private onFinish() {
    this.toggleRiskValidation();
    this.aceptedConfirm();
  }

  private onRiskValidationAbort() {
    this.toggleRiskValidation();
  }

  private toggleRiskValidation() {
    this.riskValidation = !this.riskValidation;
  }

  private get productsIds() {
    const productsIds: string[] = [];
    this.detailInfo?.productClasses.forEach(classes => {
      classes.products.forEach(product => {
        if (product?.id) {
          productsIds.push(product.id);
        }
      });
    });
    return productsIds;
  }

  public get detailInfo() {
    return this.portfolioDetails
      .detail as GlobalSummarySuggestedPortfolioDetails;
  }

  public get portfolioDetails() {
    return SuggestionModule.suggestionDetails;
  }

  public get isLoading() {
    return SuggestionModule.isFetching;
  }

  public get getError() {
    return this.error || SuggestionModule.error;
  }

  public get portfolioName() {
    return this.portfolioDetails.name;
  }

  public get portfolioId() {
    return this.portfolioDetails.id;
  }
}
